import { Injectable } from '@angular/core';
import {
  MatDialog,
  MatDialogConfig,
  MatDialogRef
} from '@angular/material/dialog';
import { Contractor } from '@authority-labs/api-interfaces';
import { CrudDialog } from '@check-list/app/classes/crud-dialog';
import { CreateContractorDialogComponent } from './create-contractor-dialog.component';

@Injectable({
  providedIn: 'root'
})
export class ContractorDialogService implements CrudDialog<Contractor> {
  private dialogConfig: MatDialogConfig;

  constructor(private dialog: MatDialog) {
    this.dialogConfig = new MatDialogConfig();
  }

  create(): MatDialogRef<CreateContractorDialogComponent, Contractor> {
    this.dialogConfig.data = new Contractor();
    return this.dialog.open(CreateContractorDialogComponent, this.dialogConfig);
  }

  edit(
    contractor?: Contractor
  ): MatDialogRef<CreateContractorDialogComponent, Contractor> {
    this.dialogConfig.data = contractor;
    return this.dialog.open(CreateContractorDialogComponent, this.dialogConfig);
  }
}
